// Chakra imports
import {
  Flex,
  useColorModeValue,
  Button,
  Grid,
  GridItem,
  TabPanel,
  Tabs,
  TabList,
  Tab,
  TabPanels
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import React, { useState } from "react";

import "react-datepicker/dist/react-datepicker.css";
import { mkConfig, generateCsv, download } from 'export-to-csv';

//////////nuevos
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import DataLabel from "views/Cards/DataLabel";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { jsPDF } from 'jspdf';
import jsonToTable from 'json-to-table';

import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es"; // the locale you want
import GrillaEffect from "views/Grillas/GrillaEffect";
import dayjs from "dayjs";
import 'dayjs/locale/es';
registerLocale("es", es); // register it with the name you want


const theme = createTheme({
  palette: {}
});

function FacturacionBatch() {

  ///exporta csv
  const csvConfig = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
  });
  const GenerarCsv = async () => {

    try {
      // Realiza la solicitud a la API       
      const baseURL = `${process.env.REACT_APP_API_URL}/querysext/21`;

      const rest = await fetch(baseURL,
        {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            "Authorization": localStorage.getItem('token'),
          },
          body: JSON.stringify({
            fdesde: new Date(startDate).toLocaleDateString(),
            fhasta: new Date(endDate).toLocaleDateString()
          })
        });

      const resulte = await rest.json();
      // console.log(" get consulta ", resulte);          
      // Convierte la respuesta a formato JSON
      const csv = generateCsv(csvConfig)(resulte);
      download(csvConfig)(csv);

    } catch (error) {
      console.error(`Error al  generar csv : ${error.message}`);
      throw error;
    }

  };

  ///exporta pdf 
  const GenerarPdf = async () => {

    try {
      // Realiza la solicitud a la API       
      const baseURL = `${process.env.REACT_APP_API_URL}/querysext/21`;

      const rest = await fetch(baseURL,
        {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            "Authorization": localStorage.getItem('token'),
          },
          body: JSON.stringify({
            fdesde: new Date(startDate).toLocaleDateString(),
            fhasta: new Date(endDate).toLocaleDateString()
          })
        });

      const resulte = await rest.json();

      const tabled = jsonToTable(resulte);
      let nombresCampos = tabled[0];
      const doc = new jsPDF();

      doc.autoTable({
        head: [nombresCampos],
        body: tabled,
        margin: { top: 10 },
        styles: {
          minCellHeight: 4,
          halign: "left",
          valign: "center",
          fontSize: 4,
        },
      });
      doc.save('pdf-cobranzas.pdf');

    } catch (error) {
      console.error(`Error al  generar csv : ${error.message}`);
      throw error;
    }

  };
  const defaultFecha = [
    { id: 'periodo_vto', value: dayjs().subtract(1, 'month').format('YYYY-MM'), col_ori: 'a.FactFec' }
  ];



  const [dataPdoConsumo, setdataPdoConsumo] = useState([]);
  const [dataPdoConsTarif, setdataPdoConsTarif] = useState([]);
  const [dataPdoConsCpt, setDataPdoConsCpt] = useState([]);
  const [dataPdoConsDetalle, setdataPdoConsDetalle] = useState([]);

  const [dataPdoVencimiento, setdataPdoVencimiento] = useState([]);
  const [dataPdoVencTarif, setdataPdoVencTarif] = useState([]);
  const [dataPdoVencCpt, setDataPdoVencCpt] = useState([]);
  const [dataPdoVencDetalle, setdataPdoVencDetalle] = useState([]);


  const [filterPdoConsumo, setfilterPdoConsumo] = useState([]);
  const [filterPdoVencimiento, setfilterPdoVencimiento] = useState([]);

  // Añadir un estado para controlar qué pestaña está activa
  const [activeMainTab, setActiveMainTab] = useState(0);

  // Determinar qué filtros usar basados en la pestaña activa
  const currentFilters = activeMainTab === 0 ? filterPdoConsumo : filterPdoVencimiento;



  const dataLabelIds = {
    0: { // IDs para la pestaña "Por periodo de Consumo"
      totalFacturado: 49,
      totalKwh: 23,
      totalSuministros: 57
    },
    1: { // IDs para la pestaña "Por periodo de Vencimiento"
      totalFacturado: 55, // Reemplaza con el ID correcto
      totalKwh: 56,       // Reemplaza con el ID correcto
      totalSuministros: 57 // Reemplaza con el ID correcto
    }
  };

  const currentIds = dataLabelIds[activeMainTab];

  const [filters, setFilters] = useState([...defaultFecha]);

  const [filtersReady, setFiltersReady] = useState(true);
  const [filterUpdateCount, setFilterUpdateCount] = useState(0);

  const handleFiltersUpdate = (newFilters, updateFunc) => {
    setFiltersReady(false); // Indicar que los filtros están cambiando
    updateFunc(newFilters);

    // Incrementar contador para forzar actualizaciones en componentes dependientes
    setFilterUpdateCount(prev => prev + 1);

    // Establecer un pequeño delay para asegurar que los filtros se hayan aplicado
    setTimeout(() => {
      setFiltersReady(true);
    }, 100);
  };

  const updateFiltersPdoConsumo = (newFilters) => handleFiltersUpdate(newFilters, setfilterPdoConsumo);
  const updateFiltersPdoVencimiento = (newFilters) => handleFiltersUpdate(newFilters, setfilterPdoVencimiento);


  const url = `${process.env.REACT_APP_API_URL}/querysextgrilla/`;

  const colPdoConsumo = {
    periodo_consumo: { caption: 'Pdo. Consumo', enableColumnFilter: true },
    importe_total: { caption: 'Total', enableColumnFilter: false },
    cantidad: { caption: 'Cantidad', enableColumnFilter: false },
  }

  const colsPdoConsumoTarifas = {
    periodo_consumo: { caption: 'Periodo Consumo' },
    categoria: { caption: 'Tarifa' },
    importe: { caption: 'Importe', enableColumnFilter: false },
    consumo: { caption: 'Consumo', enableColumnFilter: false },
    cantidad: { caption: 'Cant. Comprobantes', enableColumnFilter: false },
  }

  const colPdoConsumoCpt = {
    periodo_consumo: { caption: 'Pdo. Consumo', enableColumnFilter: true },
    concepto: { caption: 'Concepto', enableColumnFilter: true },
    importe: { caption: 'Importe', enableColumnFilter: false },
  }

  const colPdoConsumoDetalle = {
    periodo_consumo: { caption: 'Pdo. Consumo', enableColumnFilter: true },
    fact_fecha: { caption: 'Fecha Cbte.', enableColumnFilter: true },
    sum_nro: { caption: 'Suministro', enableColumnFilter: true },
    fact_let: { caption: 'Letra Cbte.', enableColumnFilter: true },
    fact_nro: { caption: 'Nro. Cbte.', enableColumnFilter: true },
    fact_cli_nom: { caption: 'Cliente', enableColumnFilter: true },
    consumo: { caption: 'Consumo', enableColumnFilter: false },
    importe_total: { caption: 'Total', enableColumnFilter: false },
    categoria: { caption: 'Tarifa', enableColumnFilter: true },
  }

  const colPdoVencimiento = {
    periodo_vencimiento: { caption: 'Pdo. Vto.', enableColumnFilter: true },
    importe_total: { caption: 'Total', enableColumnFilter: false },
    cantidad: { caption: 'Cantidad', enableColumnFilter: false },
  }

  const colsPdoVencimientoTarifas = {
    periodo_vencimiento: { caption: 'Periodo Vto.' },
    categoria: { caption: 'Tarifa' },
    importe: { caption: 'Importe', enableColumnFilter: false },
    consumo: { caption: 'Consumo', enableColumnFilter: false },
    cantidad: { caption: 'Cant. Comprobantes', enableColumnFilter: false },
  }
  const colPdoVencimientoCpt = {
    periodo_vencimiento: { caption: 'Pdo. Vto', enableColumnFilter: true },
    concepto: { caption: 'Concepto', enableColumnFilter: true },
    importe: { caption: 'Importe', enableColumnFilter: false },
  }

  const colPdoVencimientoDetalle = {
    periodo_vencimiento: { caption: 'Pdo. Vto.', enableColumnFilter: true },
    fact_fecha: { caption: 'Fecha Cbte.', enableColumnFilter: true },
    sum_nro: { caption: 'Suministro', enableColumnFilter: true },
    fact_let: { caption: 'Letra Cbte.', enableColumnFilter: true },
    fact_nro: { caption: 'Nro. Cbte.', enableColumnFilter: true },
    fact_cli_nom: { caption: 'Cliente', enableColumnFilter: true },
    consumo: { caption: 'Consumo', enableColumnFilter: false },
    importe_total: { caption: 'Total', enableColumnFilter: false },
    categoria: { caption: 'Tarifa', enableColumnFilter: true },
  }



  // const columnNames = {
  //   fact_fecha: 'Fecha Cbte.',
  //   asociado: 'Asociado',
  //   suministro: 'Suministro',
  //   sum_numero: 'Sum. Nro.',
  //   comprobante: 'Comprobante',
  //   importe: 'Importe',
  //   kw_hora: 'Kw Hora',
  //   kwh_donado: 'Kw/H Donado',
  //   año_vencimiento: 'Año Vto.',
  //   mes_vencimiento: 'Mes Vto.',
  //   area: 'Area',
  //   ruta: 'Ruta',
  //   tipo_cpte: 'Tipo Cbte.',
  //   clase_cpt: 'Clase CPT.',
  //   tarifa: 'Tarifa',
  //   barrio: 'Barrio',
  //   cancelado: 'Cancelado',
  //   grupo_cobranza: 'Grupo Cobranza',
  //   grupo_organismos: 'Grupo Organismos',
  //   periodo_vto: 'Pdo. Vto.',
  //   solo_deuda: 'Solo Deuda',
  //   avance_facturacion: 'Avance Facturacion',
  //   vencimiento: 'Vencimiento',
  //   periodo_consumo: 'Pdo. Consumo',
  //   estado: 'Estado',
  //   etapa: 'Etapa',
  //   tipo_socio: 'Tipo Socio',
  //   fecha_lectura: 'Fecha Lect.',
  //   grupo_impresion: 'Grupo Impresion',
  //   socio: 'Socio',
  //   documento_tipo: 'Doc. Tipo',
  //   documento_numero: 'Doc. Numero',
  //   consorcio: 'Consorcio',
  //   tarifa_r: 'Tarifa R.',
  //   factura_electronica: 'Fact. Elect.',
  //   actividad: 'Actividad'
  // }
  const columnNames = {
    periodo_vencimiento: { caption: 'Pdo. Vto.', enableColumnFilter: true },
    periodo_consumo: { caption: 'Pdo. Consumo', enableColumnFilter: true },
    fecha_cbte: { caption: 'Fecha Cbte.', enableColumnFilter: true },
    importe_total: { caption: 'Total', enableColumnFilter: false },
    categoria: { caption: 'Tarifa', enableColumnFilter: true },
    consumo: { caption: 'Consumo', enableColumnFilter: false },
  }

  const columnNames2 = {
    concepto: 'Concepto',
    importe: 'Importe',
    periodo_consumo: 'Pdo. Consumo',
    periodo_vto: 'Pdo. Vto.'
  }

  const columnNames3 = {
    periodo_consumo: { caption: 'Periodo Consumo' },
    categoria: { caption: 'Tarifa' },
    importe: { caption: 'Importe', enableColumnFilter: false },
    kw_hora: { caption: 'KW Hora', enableColumnFilter: false },
    cantidad: { caption: 'Cant. Comprobantes', enableColumnFilter: false },
  }
  const topToolbar = function (table) {
    return <Box>
      <DatePicker
        label="Desde"
        value={filters.find(i => i.id == 'periodo_vto').value}
        onChange={(fecha) => {
          let items = [...filters];
          const x = items.findIndex(i => i.id == 'periodo_vto')
          console.log(items[x]);
          let item = { ...items[x], value: [fecha, items[x].value[1]] };
          items[x] = item;
          table.table.setColumnFilters(items)
        }}
      />
      <DatePicker
        label="Hasta"
        value={filters.find(i => i.id == 'periodo_vto').value}
        onChange={(fecha) => {
          let items = [...filters];
          console.log('items aqui');
          const x = items.findIndex(i => i.id == 'fact_fecha')
          console.log(fecha);
          let item = { ...items[x], value: [items[x].value[0], fecha] };
          items[x] = item;
          table.table.setColumnFilters(items)
        }}
      />
    </Box>
  }
  //////////////
  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Card overflowX={{ sm: "scroll", xl: "hidden" }} pb="0px">
        <CardBody size='sm'>
          <Grid templateColumns={{ sm: "repeat(3, 1fr)", xl: "repeat(3, 1fr)" }} gap='22px'>
            <GridItem colSpan={2}>
              <Card minH='125px'>
                <CardBody px='2px'>
                  <Grid templateColumns={{ sm: "repeat(3, 1fr)", xl: "repeat(3, 1fr)" }} gap='5px'>
                    <DataLabel url={url + '?id=' + currentIds.totalFacturado}
                      filters={currentFilters}
                      columns={columnNames}
                      label={"TOTAL FACTURADO"}
                      filtersReady={filtersReady}
                      updateCount={filterUpdateCount}
                      explanationText={activeMainTab === 0 ? "Fact. x Cons. (12 meses)" : "Fact. x Vto. (desde hace 12 meses en adelante)"}
                      />
                    <DataLabel url={url + '?id=' + currentIds.totalKwh}
                      filters={currentFilters}
                      columns={columnNames}
                      label={"TOTAL KWH"}
                      isMoney={false}
                      filtersReady={filtersReady}
                      updateCount={filterUpdateCount} 
                      explanationText={activeMainTab === 0 ? "Fact. x Cons. (12 meses)" : "Fact. x Vto. (desde hace 12 meses en adelante)"}
                      />
                    <DataLabel url={url + '?id=' + currentIds.totalSuministros}
                      filters={currentFilters}
                      columns={columnNames}
                      label={"TOTAL SUMINISTROS"}
                      isMoney={false}
                      filtersReady={filtersReady}
                      updateCount={filterUpdateCount}
                      explanationText={activeMainTab === 0 ? "Fact. x Cons. (12 meses)" : "Fact. x Vto. (desde hace 12 meses en adelante)"}
                      />
                  </Grid>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem colSpan={1}>
              <Card minH='125px'>
                <Flex direction='column'>
                  <Flex
                    flexDirection='row'
                    align='center'
                    justify='center'
                    w='100%'
                    mb='25px'>
                    <Flex align='center'>
                      {/* <Button
                        fontSize='13px'
                        fontWeight='bold'
                        w='100%'
                        h='45'
                        variant='solid'
                        //colorScheme='green'
                        onClick={GenerarCsv}
                      >
                        Exportar CSV
                      </Button> */}
                    </Flex>
                    <Flex align='center'>
                      {/* <Button
                        fontSize='13px'
                        fontWeight='bold'
                        w='100%'
                        h='45'
                        variant='solid'
                        //colorScheme='red'
                        onClick={GenerarPdf}
                      >
                        Exportar PDF
                      </Button> */}
                    </Flex>
                  </Flex>
                </Flex>
              </Card>
            </GridItem>
          </Grid>
          <Card p='16px' my='5px'>
            <CardBody >
              <Tabs variant='enclosed' onChange={(index) => setActiveMainTab(index)}>
                <TabList>
                  <Tab>Por periodo de Consumo</Tab>
                  <Tab>Por periodo de Vencimiento</Tab>
                </TabList>
                <TabPanels>
                  <TabPanel p={0}>
                    <Tabs>
                      <TabList>
                        <Tab>Periodo</Tab>
                        <Tab>Tarifas</Tab>
                        <Tab>Conceptos</Tab>
                        <Tab>Detalle</Tab>
                      </TabList>
                      <TabPanels>
                        <TabPanel p={0}>
                          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                            <ThemeProvider theme={theme}>
                              <GrillaEffect
                                data={dataPdoConsumo} updateData={setdataPdoConsumo}
                                filters={filterPdoConsumo} updateFilters={updateFiltersPdoConsumo}
                                colsHeaders={colPdoConsumo}
                                idRemoto={44}
                                defaultSorting={[
                                  { id: 'periodo_consumo', desc: true },
                                ]} />
                            </ThemeProvider>
                          </LocalizationProvider></TabPanel>
                        <TabPanel p={0}>
                          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                            <ThemeProvider theme={theme}>
                              <GrillaEffect
                                data={dataPdoConsTarif} updateData={setdataPdoConsTarif}
                                filters={filterPdoConsumo} updateFilters={updateFiltersPdoConsumo}
                                colsHeaders={colsPdoConsumoTarifas}
                                idRemoto={46}
                                defaultSorting={[
                                  { id: 'periodo_consumo', desc: true },
                                  { id: 'importe', desc: true },
                                ]} />
                            </ThemeProvider>
                          </LocalizationProvider>
                        </TabPanel>
                        <TabPanel p={0}>
                          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                            <ThemeProvider theme={theme}>
                              <GrillaEffect
                                data={dataPdoConsCpt} updateData={setDataPdoConsCpt}
                                filters={filterPdoConsumo} updateFilters={updateFiltersPdoConsumo}
                                colsHeaders={colPdoConsumoCpt}
                                idRemoto={41}
                                defaultSorting={[
                                  { id: 'periodo_consumo', desc: true },
                                  { id: 'importe', desc: true },
                                ]} />
                            </ThemeProvider>
                          </LocalizationProvider>
                        </TabPanel>
                        <TabPanel p={0}>
                          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                            <ThemeProvider theme={theme}>
                              <GrillaEffect
                                data={dataPdoConsDetalle} updateData={setdataPdoConsDetalle}
                                filters={filterPdoConsumo} updateFilters={updateFiltersPdoConsumo}
                                colsHeaders={colPdoConsumoDetalle}
                                idRemoto={47}
                                defaultSorting={[
                                  { id: 'fact_fecha', desc: true },
                                  { id: 'importe_total', desc: true },
                                ]} />
                            </ThemeProvider>
                          </LocalizationProvider>
                        </TabPanel>
                      </TabPanels>
                    </Tabs>
                  </TabPanel>
                  <TabPanel p={0}>
                    <Tabs>
                      <TabList>
                        <Tab>Periodo</Tab>
                        <Tab>Tarifas</Tab>
                        <Tab>Conceptos</Tab>
                        <Tab>Detalle</Tab>
                      </TabList>
                      <TabPanels>
                        <TabPanel p={0}><LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                          <ThemeProvider theme={theme}>
                            <GrillaEffect
                              data={dataPdoVencimiento} updateData={setdataPdoVencimiento}
                              filters={filterPdoVencimiento} updateFilters={updateFiltersPdoVencimiento}
                              colsHeaders={colPdoVencimiento}
                              idRemoto={51}
                              defaultSorting={[
                                { id: 'periodo_vencimiento', desc: true },
                              ]} />
                          </ThemeProvider>
                        </LocalizationProvider></TabPanel>
                        <TabPanel p={0}><LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                          <ThemeProvider theme={theme}>
                            <GrillaEffect
                              data={dataPdoVencTarif} updateData={setdataPdoVencTarif}
                              filters={filterPdoVencimiento} updateFilters={updateFiltersPdoVencimiento}
                              colsHeaders={colsPdoVencimientoTarifas}
                              idRemoto={52}
                              defaultSorting={[
                                { id: 'periodo_vencimiento', desc: true },
                                { id: 'importe', desc: true },
                              ]} />
                          </ThemeProvider>
                        </LocalizationProvider></TabPanel>
                        <TabPanel p={0}><LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                          <ThemeProvider theme={theme}>
                            <GrillaEffect
                              data={dataPdoVencCpt} updateData={setDataPdoVencCpt}
                              filters={filterPdoVencimiento} updateFilters={updateFiltersPdoVencimiento}
                              colsHeaders={colPdoVencimientoCpt}
                              idRemoto={53}
                              defaultSorting={[
                                { id: 'periodo_vencimiento', desc: true },
                                { id: 'importe', desc: true },
                              ]} />
                          </ThemeProvider>
                        </LocalizationProvider></TabPanel>
                        <TabPanel p={0}><LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                          <ThemeProvider theme={theme}>
                            <GrillaEffect
                              data={dataPdoVencDetalle} updateData={setdataPdoVencDetalle}
                              filters={filterPdoVencimiento} updateFilters={updateFiltersPdoVencimiento}
                              colsHeaders={colPdoVencimientoDetalle}
                              idRemoto={54}
                              defaultSorting={[
                                { id: 'fact_fecha', desc: true },
                                { id: 'importe_total', desc: true },
                              ]} />
                          </ThemeProvider>
                        </LocalizationProvider></TabPanel>
                      </TabPanels>
                    </Tabs>
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </CardBody>
          </Card>
        </CardBody>
      </Card>
    </Flex>

  );
}



export default FacturacionBatch;